import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { ItemDocumentFinderTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ItemDocumentFinderTheme>;
const css = baseCss as ThemedCssFunction<ItemDocumentFinderTheme>;

export const ItemDocumentFinder = styled.div`
  width: 100%;
  height: 100%;


`;
